import { ref } from 'vue';
import { useEcho } from '@laravel/echo-vue';
import { EchoBroadcast } from '@apparatix/constants/EchoBroadcast';

export const useStateSync = (tenantId: string, userId: number) => {
  const channelName = ref(`tenants.${tenantId}.${userId}.stateSync`);

  const subscribe = <T>(eventName: keyof typeof EchoBroadcast.stateSyncEvent, callback: (data: T) => void) => {
    const { listen, stopListening } = useEcho<T>(channelName.value, eventName, eventData => {
      if (typeof callback === 'function') {
        callback(eventData);
      }
    });

    return [stopListening, listen];
  };

  return {
    subscribe,
  };
};
